import React from 'react'

function Auth(): JSX.Element {
  return <div>Auth</div>
}

export default Auth
